import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { CustomAlertComponent } from "../components/custom-alert/custom-alert.component";

@Injectable({
    providedIn: "root",
})
export class AlertService {
    constructor(private _snackBar: MatSnackBar) {}

    public openSnackBar(
        message: string,
        actionText: string = "",
        duration: number = 0,
    ): MatSnackBarRef<CustomAlertComponent> {
        if (!actionText) actionText = "Dismiss";
        if (duration <= 0) duration = 3000;

        return this._snackBar.openFromComponent(CustomAlertComponent, {
            duration: duration,
            data: { message: message || "Something went wrong" },
        });
    }
    public dismissVisibleSnackBar(): void {
        this._snackBar.dismiss();
    }
}
